// src/pages/IssueReporting/components/TicketsFilters.js
import React from 'react';
import {
    Grid,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Tooltip
} from '@mui/material';
import { Search as SearchIcon, XCircle } from 'react-feather';
import { RefreshCwIcon } from "lucide-react";

const TicketsFilters = ({
                            searchTerm,
                            statusFilter,
                            priorityFilter,
                            handleSearchChange,
                            handleStatusFilterChange,
                            handlePriorityFilterChange,
                            resetFilters,
                            handleRefresh
                        }) => {
    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
                <TextField
                    fullWidth
                    placeholder="Search tickets..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    variant="outlined"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon size={18}/>
                            </InputAdornment>
                        ),
                        sx: {borderRadius: '8px'}
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                    <InputLabel id="status-filter-label">Status</InputLabel>
                    <Select
                        labelId="status-filter-label"
                        id="status-filter"
                        value={statusFilter}
                        onChange={handleStatusFilterChange}
                        label="Status"
                        sx={{borderRadius: '8px'}}
                    >
                        <MenuItem value="All">All Statuses</MenuItem>
                        <MenuItem value="OPEN">Open</MenuItem>
                        <MenuItem value="IN PROGRESS">In Progress</MenuItem>
                        <MenuItem value="RESOLVED">Resolved</MenuItem>
                        <MenuItem value="CLOSED">Closed</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                    <InputLabel id="priority-filter-label">Priority</InputLabel>
                    <Select
                        labelId="priority-filter-label"
                        id="priority-filter"
                        value={priorityFilter}
                        onChange={handlePriorityFilterChange}
                        label="Priority"
                        sx={{borderRadius: '8px'}}
                    >
                        <MenuItem value="All">All Priorities</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="Medium">Medium</MenuItem>
                        <MenuItem value="Low">Low</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={2} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                <Tooltip title="Refresh tickets">
                    <IconButton onClick={handleRefresh}>
                        <RefreshCwIcon size={20}/>
                    </IconButton>
                </Tooltip>
                <Tooltip title="Reset filters">
                    <IconButton
                        onClick={resetFilters}
                        disabled={!searchTerm && statusFilter === 'All' && priorityFilter === 'All'}
                        sx={{ ml: 1 }}
                    >
                        <XCircle size={20}/>
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

export default TicketsFilters;